import { gql } from 'graphql-tag'

export const SUBSCRIPTION_POST_TYPING_STATUS_USER_PRESENCE = gql`
  subscription PostTypingStatusUserPresence($key: String!) {
    user_presence(where: { key: { _eq: $key }, expired_at: { _gt: "now()" } }) {
      user {
        id
        virtual_display_name
      }
    }
  }
`
